// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"224945a69e9e619aa152","655":"5cd98e979e8792486013"}[chunkId] + ".js";
};